var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.292892 3.29289C-0.0976315 3.68342 -0.0976315 4.31658 0.292892 4.70711L6.65685 11.0711C7.04738 11.4616 7.68054 11.4616 8.07107 11.0711C8.46159 10.6805 8.46159 10.0474 8.07107 9.65685L2.41421 4L8.07107 -1.65685C8.46159 -2.04738 8.46159 -2.68054 8.07107 -3.07107C7.68054 -3.46159 7.04738 -3.46159 6.65685 -3.07107L0.292892 3.29289ZM26 3L1 3V5L26 5V3Z","fill":"#3D3636"}));
}

ArrowLeft.defaultProps = {"width":"26","height":"8","viewBox":"0 0 26 8","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
